import { useQuery } from 'react-query';
import { requestInstallerAccessEnabled } from './services';

/** Cached for a minute so moving between Settings tabs does not ask again. */
const STALE_MS = 60_000;

/**
 * True only when Swiftlane has turned Installer access on for this account. Loading and failure are both
 * false, so the tab never flashes in and a failed check hides it rather than offering what the server
 * would refuse.
 */
const useInstallerAccessEnabled = (): boolean => {
    const { data } = useQuery(['installer-access-enabled'], requestInstallerAccessEnabled, {
        retry: false,
        staleTime: STALE_MS,
    });
    return data === true;
};

export default useInstallerAccessEnabled;
